import styled from "styled-components";

const HR = styled.hr`
  border: 1px solid #eee;
`;

export default HR;
